module.exports = __webpack_public_path__ + "img/ic_trash.daf36a01.svg";